import {useEffect, useState} from 'react';
import {Table, Row} from 'antd';
import {toFSDateTime} from "../../util/timeutils";
import {TextChangeWidget} from "../widget/TextChangeWidget";
import {getPurchaseOrderLabor, updatePurchaseOrderLabor} from "../../api/Api";
import {handleNoSession} from "../../util/errorUtils";
import {QuantityEntryWidget} from "./QuantityEntryWidget";
import {UnitType} from "../../api/Constants";

export const POLaborTable = ({session, purchaseOrder, io, props}) => {
    const {refresh, onRefresh, onApiFail} = io;
    const [notes, setNotes] = useState([]);

    useEffect(() => {
        if (purchaseOrder === undefined) {
            return;
        }

        getPurchaseOrderLabor(purchaseOrder.id).then(r => {
            const nextNotes = r.map(row => {
                return {...row, key: row.id}
            }).sort((a, b) => {
                const {timestamp: aTime} = a;
                const {timestamp: bTime} = b;
                return new Date(aTime)- new Date(bTime);
            });
            setNotes(nextNotes);
        }).catch(e => {
            handleNoSession(e, onApiFail);
        });

    }, [purchaseOrder, refresh, onApiFail])

    const onNotesChange = (record) => (newNotes) => {
        updatePurchaseOrderLabor(record.purchaseId, record.id, newNotes, record.hours).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            console.log(`failed to update purchase order labor notes`);
            handleNoSession(e, onApiFail);
        })
    }

    const onHourChange = (record) => (newHours) => {
        updatePurchaseOrderLabor(record.purchaseId, record.id, record.notes, newHours).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            console.log(`failed to update purchase order labor hours`);
            handleNoSession(e, onApiFail);
        })
    }

    const columns = [
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            render: (val, record) => {
                if (session.id === record.userId) {
                    return <TextChangeWidget text={val} maxLength={2048} rows={4} onTextSave={onNotesChange(record)}/>
                } else {
                    // do not allow edits
                    return val;
                }
            }
        },
        {
            title: 'Author',
            dataIndex: 'firstname',
            key: 'author',
            render: (val, record, index) => {
                return `${record.firstname} ${record.lastname}`;
            }
        },
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                return toFSDateTime(new Date(val));
            }
        },
        {
            title: 'Hours',
            dataIndex: 'hours',
            key: 'hours',
            render: (val, record) => {
                if (session.id === record.userId) {
                    return <QuantityEntryWidget placeholder={'Hours'} title={'Hours'} unit={UnitType.Hour} onQuantityChange={onHourChange(record)} value={val} useLabel={false} />
                } else {
                    return val;
                }
            }
        }
    ];

    if (notes.length === 0) {
        return <div/>
    }

    const rowStyle = {
        marginTop: '5px',
        marginLeft: '10px',
        marginBottom: '15px',
    }

    const hourSum = notes.reduce((acc, record) => {
        return acc + record.hours;
    }, 0).toFixed(1);

    return <div>
        <Row style={{...rowStyle, color: "#108ee9"}}>
            {`Total ${hourSum} hours`}
        </Row>
        <Table dataSource={notes} columns={columns} pagination={false} />
    </div>
}